/* eslint-disable @typescript-eslint/no-unused-vars */
import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

import { Observable } from 'rxjs';

import { APP_CONFIG, IAppConfig } from '@app/core/services/app.config';

@Injectable()
export class IsPlacesVisibleGuard implements CanActivate {
  constructor(
    @Inject(APP_CONFIG) private readonly appConfig: IAppConfig,
    private router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.appConfig.settings.is_places_hidden
      ? this.router.createUrlTree(['/events'])
      : true;
  }
}
